import React, { useState, useEffect } from "react";
import axios from "axios";
import { alert_error, alert_success } from "../../../../AppContext.js";

const Mission_edit = ({ item, set_data_edit }) => {
  const [nutxuly, setNutxuly] = useState(0);
  const [nutorder, setNutorder] = useState("Xác nhận");
  const [editedItem, setEditedItem] = useState(null);

  // Ví dụ về biến bổ sung được gửi cùng với id_mission
  const extraVariable = "your_extra_value_here";

  // Khi component mới mount, gọi API get_info.php để lấy thông tin mission gốc
  useEffect(() => {
    axios
      .post("https://hust.media/jop/mission/admin/get_info.php", {
        id_mission: item.id,
        extra: extraVariable, // Gửi thêm biến extra nếu cần
      })
      .then((response) => {
        const info = response.data;
        if (info.success) {
          // Set dữ liệu mission gốc vào state để cho người dùng chỉnh sửa
          setEditedItem(info.data);
        } else {
          alert_error(info.error || "Không lấy được thông tin mission");
        }
      })
      .catch((error) => {
        console.error(error);
        alert_error("Lỗi khi lấy thông tin mission");
      });
  }, [item.id, extraVariable]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!editedItem) return; // Chưa có dữ liệu từ API

    // Kiểm tra dữ liệu bắt buộc, ví dụ: api_category không được rỗng
    if (!editedItem.api_category) {
      alert("Please điền đầy đủ thông tin");
      setNutxuly(0);
      setNutorder("điền đủ thông tin");
      return;
    }

    setNutxuly(1);
    setNutorder("Please wait a moment 😊");

    // Gửi dữ liệu đã chỉnh sửa sang API mission_edit.php
    axios
      .post("https://hust.media/jop/mission/admin/mission_edit.php", {
        data_edit: editedItem,
      })
      .then((response) => {
        testFunction(response);
        setNutorder("đặt tiếp luôn nào");
        setNutxuly(0);
      })
      .catch((error) => {
        console.error(error);
        setNutorder("Xác nhận");
        setNutxuly(0);
        alert_error(error.message || "Có lỗi xảy ra");
      });
  };

  function testFunction(response) {
    const info = response.data;
    if (info.status === 0) {
      alert_error(info.message);
    } else if (info.status === 1) {
      alert_success(info.message);
    }
    if (info.redirect) {
      setTimeout(() => {
        window.location.href = info.redirect;
      }, 1700);
    }
  }

  // Render các input cho các key của editedItem (ngoại trừ id)
  const renderInputs = () => {
    if (!editedItem) return <div>Loading...</div>;
    return Object.keys(editedItem)
      .filter((key) => key !== "id")
      .map((key) => (
        <div className="input-group flex-nowrap" key={key}>
          <span className="input-group-text" id="addon-wrapping">
            {key}
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Có thể bỏ trống"
            aria-label={key}
            value={editedItem[key] || ""}
            name={key}
            aria-describedby="addon-wrapping"
            onChange={(e) => {
              // Cập nhật state cục bộ khi người dùng chỉnh sửa
              setEditedItem({
                ...editedItem,
                [key]: e.target.value,
              });
            }}
          />
        </div>
      ));
  };

  return (
    <form onSubmit={handleSubmit} className="mx-2 mb-1 add-form">
      <div className="form-control">
        <div className="flex items-center justify-between flex-1">
          <label className="mb-2 text-lg">Chỉnh sửa link {item.id}</label>
          <label onClick={() => set_data_edit(null)} className="mb-2 px-2 cursor-pointer">
            Đóng
          </label>
        </div>

        {renderInputs()}

        <button
          disabled={nutxuly === 1}
          type="submit"
          className="mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white"
        >
          <div className="flex items-center justify-between flex-1">
            {nutxuly === 1 && (
              <div className="spinner-border" role="status">
                {/* Spinner nếu cần */}
              </div>
            )}
            <span className="text-lg font-medium text-white">{nutorder}</span>
            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
          </div>
        </button>
      </div>
    </form>
  );
};

export default Mission_edit;
